module.exports = __webpack_public_path__ + "img/c-4.2a0fd8f4.jpg";